<template><div class="progress-bar" /></template>

<script lang="ts">
import { clamp } from 'ramda'
import { computed, defineComponent } from 'vue'

export default defineComponent({
  props: {
    value: {
      type: Number,
      required: true,
    },
  },
  setup(props) {
    return { progress: computed(() => `${clamp(0, 1, props.value) * 100}%`) }
  },
})
</script>

<style lang="postcss">
.progress-bar {
  width: 100%;
  height: 1rem;
  border-radius: 6px;
  background-color: rgb(184, 184, 185);
  overflow: hidden;

  &::after {
    content: '';
    display: block;
    border-radius: inherit;
    height: 100%;
    min-width: 0;
    max-width: 100%;
    width: v-bind(progress);
    background-color: #50e391;

    transition: 0.04s width ease-in-out;
  }
}
</style>
